import { EafDataEntryPage } from "./DataEntryPage";
import { EAFDataEntryProvider } from "./context/reducer.provider";
import { TimerProvider } from "./context/timer.provider";

import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { useEffect } from "react";
import theme from "./theme/theme";

type Props = {};
const EAFDataEntry = (props: Props) => {
	useEffect(() => {
		const [nav] = performance.getEntriesByType(
			"navigation",
		) as PerformanceNavigationTiming[];
		if (nav?.type === "reload" || nav?.type === "navigate") {
			localStorage.removeItem("dismiss_timestamp");
		}
	}, []);

	return (
		<MuiThemeProvider theme={theme}>
			<EAFDataEntryProvider>
				<TimerProvider>
					<div
						id={"dummy"}
						style={{ height: "0", width: "0" }}
						tabIndex={-1}
					></div>
					<EafDataEntryPage />
				</TimerProvider>
			</EAFDataEntryProvider>
		</MuiThemeProvider>
	);
};
export default EAFDataEntry;
